import { Check } from "lucide-react";

const labels = [
  "Address & Property",
  "Items to Collect",
  "Room Photos",
  "Preferred Date",
  "Your Details",
  "Summary",
];

export default function StepIndicator({ current }) {
  return (
    <div className="w-full" data-testid="wizard-step-indicator">
      {/* Numeric row */}
      <ol className="flex items-start gap-1 sm:gap-2">
        {labels.map((label, idx) => {
          const step = idx + 1;
          const done = step < current;
          const active = step === current;
          return (
            <li key={label} className={`${step < labels.length ? "flex-1" : "flex-none"} min-w-0 flex items-start`}>
              <div className="flex flex-col items-center flex-1 min-w-0">
                <div
                  data-testid={`step-dot-${step}`}
                  className={`h-8 w-8 sm:h-9 sm:w-9 shrink-0 rounded-full flex items-center justify-center text-sm font-bold border-2 transition-all ${
                    done
                      ? "bg-[#FF7F00] text-white border-[#FF7F00]"
                      : active
                      ? "bg-white text-[#FF7F00] border-[#FF7F00] shadow-md shadow-orange-100"
                      : "bg-white text-slate-400 border-slate-200"
                  }`}
                >
                  {done ? <Check className="h-4 w-4" /> : step}
                </div>
                <p
                  className={`hidden sm:block mt-2 text-xs font-medium text-center leading-tight whitespace-nowrap ${
                    active ? "text-slate-900" : "text-slate-500"
                  }`}
                >
                  {label}
                </p>
              </div>
              {step < labels.length && (
                <div
                  className={`h-0.5 flex-1 min-w-[6px] mx-1 sm:mx-2 mt-4 sm:mt-[18px] ${
                    done ? "bg-[#FF7F00]" : "bg-slate-200"
                  }`}
                />
              )}
            </li>
          );
        })}
      </ol>
      <p className="sm:hidden mt-3 text-center text-sm font-semibold text-slate-900" data-testid="step-indicator-mobile-label">
        Step {current} of {labels.length}: <span className="text-[#FF7F00]">{labels[current - 1]}</span>
      </p>
    </div>
  );
}
